<template>
  <div>
    <div>
      <img src="https://demoparkapi.kunxiangparking.com/Images/resources/pay_image_awarenessrate@3x.png" alt=""
        width="100%" />
    </div>
    <!-- 输入车牌号 -->
    <div style="margin: 20px">
      <van-form @submit="getPayInfo">
        <LicensePlate style="font-size: 18px" v-model="carNumber" @change="handleChange" />

        <!-- <van-field
          v-model="carNumber"
          name="车牌号码"
          label="车牌号码"
          placeholder="请输入车牌号码"
          @input="convertToUppercase"
          :rules="[{ validateLicensePlate, message: '请输入正确车牌号码' }]"
        /> -->
        <!-- 车牌选择 -->
        <div class="" style="display: flex; margin: 10px 20px; flex-wrap: wrap;">
          <div class="car_number color3 font-w" style="color: #333;" v-for="(item, index) in carNoList" :key="index">
            <span @click="selcectCarNo(item.carNo)">
              {{ item.carNo }}
              <span style="margin-left:20rpx;" @click.stop="delCarNumber(item)">×</span>
            </span>
            <div class="bottomBorder"></div>
          </div>
        </div>
        <div style="margin: 16px">
          <!-- <van-button plain type="primary" native-type="submit">查询</van-button> -->
          <van-button block type="info" size="normal" native-type="submit">查询</van-button>
        </div>
      </van-form>
    </div>
    <van-dialog v-model="showParkingInfo" title="缴费信息" :showConfirmButton="false" close-on-click-overlay width="100%">
      <div style="padding: 30px 0">
        <van-notice-bar scrollable text="请仔细核对车牌号码，请您缴费后在15分钟内离场，否则将会重新计费！" style="font-size: 16px" />
        <!-- 车场信息 -->
        <div>
          <div class="parkName text_c">{{ parkingInfo.parkingName }}</div>
          <div class="blueCarNumber" style="margin: 10px auto">
            {{ parkingInfo.orderInfo.name | formatLicensePlate }}
          </div>
        </div>
        <!-- 停车缴费信息 -->
        <div>
          <div class="card flex2">
            <div style="
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
              ">
              <p class="title">入场时间</p>
              <div class="parkInfo">{{ parkingInfo.orderInfo.entryTime }}</div>
            </div>
            <div style="
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
              ">
              <p class="title">停车时长</p>
              <div class="parkInfo">{{ parkingInfo.carParkingTime }}</div>
            </div>
          </div>
          <div class="text_c price_text" style="margin: 10px 0">
            实付金额：<span class="price">{{ parkingInfo.actualMoney }}</span>元
          </div>
        </div>
        <div style="padding: 15px 50px" v-show="parkingInfo.actualMoney != '0.00'">
          <van-button type="info" size="large" @click="getParkingRoadInfo">立即缴费</van-button>
        </div>
      </div>
    </van-dialog>

    <van-dialog v-model="showRide" title="" :showConfirmButton="false" close-on-click-overlay width="100%">
      <div>
        <div style="
            font-size: 20px;
            background: linear-gradient(#0098fd, #0070fc);
            padding: 15px;
            color: #fff;
          ">
          高新区<span style="color: #c4d32d; margin-left: 5px">路侧停车费缴纳</span>
        </div>
        <div style="text-align: start; padding: 10px 20px; font-size: 18px">
          <span style="font-weight: 700">{{ parkingInfo.orderInfo.name }}</span>
          欠费明细
        </div>
        <div class="scroll-container">
          <!-- 列表容器 -->
          <van-list v-model="loading" :finished="finished" class="scroll-list" @load="getRoadParkingList(currentPage)"
            finished-text="没有更多数据">
            <div v-for="(item, index) in roadList" :key="index">
              <div class="item">
                <van-checkbox-group v-model="selectedIds">
                  <van-checkbox :key="item.recordId" :name="item.recordId" />
                </van-checkbox-group>
                <div style="
                    display: flex;
                    width: 100%;
                    overflow: hidden;
                    justify-content: space-between;
                  ">
                  <div class="item-content" style="width: 60%">
                    <div class="ellipsis">车场: {{ item.parkName }}</div>
                    <div class="font-30">时长: {{ item.duration }}</div>
                    <div class="font-30">日期: {{ item.inTime }}</div>
                  </div>
                  <div class="flex" style="
                      display: flex;
                      justify-content: flex-end;
                      flex-direction: column;
                      padding-right: 10px;
                      width: 40%;
                    ">
                    <div :class="item.isBluePlate
                      ? 'blueListCarNumber'
                      : 'greenListCarNumber'
                      ">
                      {{ item.vplNumber }}
                    </div>
                    <div class="mt-2" style="
                        font-size: 24px;
                        color: #ff8f1f;
                        font-weight: 500;
                        text-align: end;
                      ">
                      ￥{{ item.amount }}
                    </div>
                  </div>
                </div>
              </div>
              <van-divider :style="{ margin: '10px 0' }" />
            </div>
          </van-list>
        </div>
        <div style="
            display: flex;
            justify-content: space-between;
            padding: 0 10px;
            margin-top: 20px;
          ">
          <!-- <van-checkbox
            v-model="isAllCheck"
            @change="checkAllChange"
            label="全选"
            >全选</van-checkbox
          > -->
          <div>
            <van-button type="primary" size="small" @click="checkAll">全选</van-button>
            <van-button style="margin-left: 10px" type="info" size="small" @click="toggleAll">反选</van-button>
          </div>

          <div class="">
            共<span class="font-32 font-w px-1" style="padding: 0 5px">{{
              totalCount
            }}</span>笔 已选<span class="font-32 font-w" style="padding: 0 5px">{{
                selectedIds.length
              }}</span>笔
          </div>
        </div>
        <!-- <div
          class="px-4"
          style="
            color: #ff8f1f;
            font-weight: 500;
            text-align: end;
            padding: 0 20px;
          "
        >
          <span class="font-32" style="font-size: 16px">欠费合计：</span>
          <span class="font-38" style="font-size: 24px"
            >￥{{ roadInsideAmount }}</span
          >
        </div> -->
        <div style="
            background: linear-gradient(#e5eeff, #bdd1f7);
            padding: 8px 20px;
            margin-top: 10px;
            border-radius: 0 0 4px 4px;
          ">
          <div class="" style="line-height: 20px; font-size: 14px">
            如需开票或有疑问，请联系<a href="tel:02989522659" class="ml-1" style="color: #1677ff">029-89522659</a>
          </div>
          <!-- <div
            class=""
            style="color: #1677ff; font-size: 14px"
            @click="toPathAuthorization()"
          >
            《欠费追缴授权书》
          </div> -->
        </div>

        <!-- 支付信息 -->
        <div style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            margin-top: 10px;
            font-weight: 500;
            color: #ff8f1f;
          ">
          <div>
            <span class="font-50 pr-3" style="font-size: 24px">￥{{ totalAmount / 100 }}</span>
            <div class="font-32" style="font-size: 12px">
              临停：{{ parkingInfo.orderInfo.actualToll / 100 }} 元，路侧：{{
                roadInsideAmount
              }}元
            </div>
            <!-- <div class="font-32" style="font-size: 12px">(共计=临停+路侧)</div> -->
          </div>
          <van-button type="info" style="width: 120px; height: 40px" size="large" @click="gopay">去支付</van-button>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { getWxUserLoginH5, getPreOrderInfo, getOrderPayInfo, getAliUserLoginH5, checkPre, getHistoryCarNumber, addHistoryCarNumber, delHistoryCarNumber } from '@/api/h5'
import { getParkingRoad, getRoadOrder } from '@/api/road'
export default {
  props: {

  },
  data() {
    return {
      parkingInfo: {
        orderInfo: {
          name: ''
        }
      },
      showParkingInfo: false,
      carNumber: '',
      parkId: '',
      areaId: '',
      //  重定向获取的code信息
      code: '',
      authCode: '',

      showRide: false,
      loading: false, // 控制加载状态
      finished: false, // 控制是否完成加载
      roadList: [],
      isAllCheck: false,//是否全选
      currentPage: 1,  // 当前页数
      totalPages: 1,//总页数
      totalCount: 1,//总条数
      selectedIds: [], // 选中的id集合
      roadInsideAmount: 0,  // 选中的总金额
      roadInsideRecord: '',  // 拼接code
      totalAmount: 0,// 路侧总金额 + 临停费用

      sourceType: 1, // 1 微信 2 支付宝

      carNoList: [],

      // TODO
      roadOrderNum: 0, //合并追缴的订单数
    };
  },
  filters: {
    keepTwo(value) {
      var toFixedNum = Number(value).toFixed(3);
      var realVal = toFixedNum.substring(0, toFixedNum.toString().length - 1);
      return realVal;
    },
    formatLicensePlate(value) {
      if (value && typeof value === 'string') {
        // 取车牌号的前两位与后面的部分，用 · 连接
        return value.slice(0, 2) + '·' + value.slice(2);
      }
      return value;
    }
  },
  components: {

  },
  computed: {

  },
  watch: {
    selectedIds(val) {
      console.log(this.findItemsByIds(val));
      let list = this.findItemsByIds(val)
      this.updateSelectedInfo(list)
      if (val.length == this.totalCount) {
        this.isAllCheck = true
      } else {
        this.isAllCheck = false
      }
    },
  },
  created() {
    //获取当前url   取到code 
    var url = window.location.href;
    var params = this.parse_url(url);
    this.parkId = params.parkId
    this.areaId = params.areaId
    this.code = params.code



    if (params.source == 'alipay_wallet') {
      this.sourceType = 2
      this.authCode = params.auth_code
      this.initALiOrderInfo()
    } else {
      this.code = params.code
      this.initOrderInfo()
    }
  },
  mounted() {
  },
  methods: {
    handleChange(val) {
      // val 包含 array, value, pass 等属性
      console.log('车牌变化:', val.value, '是否通过验证:', val.pass)
      this.carNumber = val.value
    },
    selcectCarNo(i) {
      this.carNumber = i
    },
    async getCarNumberList() {
      const { data } = await getHistoryCarNumber({
        openId: sessionStorage.getItem('Token'),
        type: 1, // 1预支付 2包月
        currentPage: 1,
        pageSize: 5
      })
      if (data.code == 200) {
        this.carNoList = data.rows
        console.log(this.carNoList)
      }
    },
    // 新增车牌号
    async addCarNumber() {
      const { data } = await addHistoryCarNumber({
        openId: sessionStorage.getItem('Token'),
        type: 1, // 1预支付 2包月
        carNo: this.carNumber
      })
      if (data.code == 200) {
        this.getCarNumberList()
      }
    },
    // 删除车牌号
    async delCarNumber(i) {
      const { data } = await delHistoryCarNumber({
        ids: [i.id]
      })
      if (data.code == 200) {
        Toast('删除成功')
      }
    },
    toPathAuthorization() {
      this.$router.push('/authorization')
    },
    convertToUppercase(value) {
      // 输入发生变化时，自动将小写字母转为大写
      this.carNumber = value.toUpperCase();
    },
    // 车牌号校验正则表达式
    validateLicensePlate(plateNumber) {

      // 新能源
      let xny = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([A-HJ-K][A-HJ-NP-Z0-9][0-9]{4}$))/;

      // 燃油车
      let ryc = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;

      if (plateNumber.length == 7) {
        return ryc.test(plateNumber)
      } else if (plateNumber.length == 8) {
        return xny.test(plateNumber)
      }
    },
    findItemsByIds(ids) {
      return this.roadList.filter(item => ids.includes(item.recordId));
    },
    //转码
    parse_url(url) { //定义函数
      var pattern = /(\w+)=(\w+)/ig; //定义正则表达式
      var parames = {}; //定义数组
      url.replace(pattern, function (a, b, c) {
        parames[b] = c;
      });
      return parames; //返回这个数组.
    },
    // 支付宝初始化获取信息
    async initALiOrderInfo() {
      /*
          获取链接code
          获取车牌号
          获取车场id
          获取区域id
      */
      const { data } = await getAliUserLoginH5({
        // 动态获取
        authCode: this.authCode,
        parkId: this.parkId,
      })
      if (data.code == 200) {
        if (Object.entries(data.data).length) {
          const res = data.data
          sessionStorage.setItem('Token', res.token)

        } else {
          Toast('登录失败，请重新扫描二维码')
        }
      } else {
        Toast(data.msg)
      }
    },
    // 初始化获取信息
    async initOrderInfo() {
      /*
          获取链接code
          获取车牌号
          获取车场id
          获取区域id
      */
      const { data } = await getWxUserLoginH5({
        // 动态获取
        code: this.code,
        parkId: this.parkId,
      })
      if (data.code == 200) {
        // 确保token获取成功
        if (Object.entries(data.data).length) {
          const res = data.data
          sessionStorage.setItem('Token', res.token)
          this.getCarNumberList()
        } else {
          Toast('登录失败，请重新扫描二维码')
        }
      } else {
        Toast(data.msg)
      }
    },
    async getPayInfo() {
      Toast.loading({
        message: '查询中...',
        forbidClick: true,
        duration: 0
      });
      /*
          获取链接code
          获取车牌号
          获取车场id
          获取区域id
      */
      const { data } = await getPreOrderInfo({
        carNo: this.carNumber,
        parkId: this.parkId,
        areaId: this.areaId
      })
      if (data.code == 200) {
        console.log(data)
        this.parkingInfo = data.data
        this.showParkingInfo = true
        this.addCarNumber()
        Toast.clear()
      } else {
        Toast(data.msg)
      }
    },
    // 查询当前车场是否支持追缴
    async getParkingRoadInfo() {
      const { data } = await getParkingRoad({
        parkId: this.parkId
      })
      if (data.code == 200) {
        /*
        * 0 均不支持
        * 1 均支持
        * 2 出口码支持
        * 3 预支付码支持
        * */
        if (data.data.isRoadInsidePay == 1 || data.data.isRoadInsidePay == 2) {
          // 初始化总计金额
          this.totalAmount = (this.roadInsideAmount * 100) + Number(this.parkingInfo.orderInfo.actualToll)

          // 路侧缴费订单数TODO
          this.roadOrderNum = data.data.numberOfRoadsideSeizures
          this.getRoadParkingList()
        } else {
          this.gopay()
          this.roadInsideAmount = 0
          this.roadInsideRecord = 0
          this.totalAmount = 0
        }
      } else {
        Toast(data.msg);
      }
    },
    // 查询路侧订单列表
    async getRoadParkingList() {
      this.roadInsideAmount = 0
      this.roadInsideRecord = 0
      this.totalAmount = 0
      this.selectedIds = []
      const { data } = await getRoadOrder({
        // carNumber: '陕AAW1695',
        carNumber: this.parkingInfo.orderInfo.name,
        currentPag: this.currentPage,
        pageSize: 10
      })
      if (data.data.roadSideRecordList.length > 0) {
        this.showRide = true
        data.data.roadSideRecordList.forEach(k => {
          k.selected = false
          if (k.vplNumber.length == 7) {
            k.isBluePlate = true
          }
        })
        // 合并下拉加载数据
        const mergedList = [...this.roadList, ...data.data.roadSideRecordList];

        this.roadList = mergedList.filter((value, index, self) =>
          index === self.findIndex((t) => (
            t.recordId === value.recordId
          ))
        );
        // this.roadList = [...this.roadList, ...data.data.roadSideRecordList];
        this.totalPages = data.data.totalPages
        this.totalCount = data.data.totalCount

        this.loading = false
        this.currentPage++
        if (this.currentPage > 2) {
          this.finished = true
        }

      } else {
        // TODO 处理无欠费订单
        this.roadOrderNum = 0
        this.gopay()

        return
      }
    },
    async gopay() {
      // 如果code已经使用过或失效。跳转至重定向页面进行重定向处理
      //   if (sessionStorage.getItem('Token') == 'undefined') {
      //     debugger
      //     this.$router.push('/');
      //   }
      Toast.loading({
        message: '支付中...',
        forbidClick: true,
        duration: 0
      });

      // TODO
      let roadNum = 0
      if (this.roadInsideRecord != '') {
        roadNum = this.roadInsideRecord.split(',').length
      }
      if (roadNum >= this.roadOrderNum) {
        const checkMsg = await checkPre({
          onSiteCode: this.parkingInfo.orderInfo.onSiteCode,
          parkCode: this.parkingInfo.orderInfo.parkCode,
          preOrderCode: this.parkingInfo.orderInfo.code
        })
        if (checkMsg.data.code == 200) {
          const { data } = await getOrderPayInfo({
            orderNo: this.parkingInfo.orderInfo.code,
            orderId: this.parkingInfo.orderInfo.id,
            name: this.parkingInfo.orderInfo.name,
            price: this.parkingInfo.orderInfo.price,
            parkId: this.parkingInfo.orderInfo.parkId,
            openId: sessionStorage.getItem('Token'),
            areaId: this.parkingInfo.orderInfo.areaId,
            aisleId: this.parkingInfo.orderInfo.aisleId,
            laneId: this.parkingInfo.orderInfo.laneId,
            paymentType: this.sourceType, // 1 微信支付宝 2 支付宝支付
            // paymentType: 1,
            paymentSource: 1,//1==公众号 0==小程序
            carType: this.parkingInfo.orderInfo.carType,
            carId: this.parkingInfo.orderInfo.carId,
            isPreOrder: this.parkingInfo.isPreOrder,
            token: sessionStorage.getItem('Token'),

            roadInsideAmount: 1,
            roadInsideAmount: this.roadInsideAmount * 100,
            // roadInsideAmount: Math.round(this.roadInsideAmount * 100),
            roadInsideRecord: this.roadInsideRecord,
            totalAmount: this.totalAmount
            // totalAmount: Math.round(this.totalAmount),
          })
          if (data.code == 200) {
            const res = data.data
            /**
             * 西安银行支付（微信、支付宝）
             * 判断是否存在isJump 且 == 1  ==>  西安银行支付
             * 取 jumpUrl： webview  跳转链接
             */
            // 西安银行支付跳转
            if (res?.isJump == 1) {
              window.location.href = res.jumpUrl
            }
            else {
              // 微信支付
              if (this.sourceType == 1) {
                // 由于微信内置对象加载需要时间
                if (typeof WeixinJSBridge == "undefined") {
                  if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                  } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                    document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                  }
                } else {
                  this.onBridgeReady(res);
                }
              }
              // 支付宝支付
              else {
                this.ALiPayReady(res)
              }
              Toast.clear()
            }
            // onBridgeReady(res)
          } else {
            Toast(data.msg)
          }
        }
        else {
          Toast(checkMsg.data.msg)
        }
      }
      else {
        Toast(`至少选择${this.roadOrderNum}条路侧停车费`)
      }

    },

    onBridgeReady(data) {
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
        appId: data.appid,       	 // 公众号id
        timeStamp: data.timestamp,   	 // 时间戳
        nonceStr: data.noncestr,     	 // 随机串
        package: data.packageValue,         // 订单详情扩展字符串
        signType: data.signType,     	 // 微信签名方式
        paySign: data.sign          // 微信签名
      }, (res) => {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          //res.err_msg将在用户支付成功后返回ok，这时调取你本身服务端业务查询，若已支付成功，则跳转成功页面，展示给用户。
          this.$router.replace('successPay')
        }
      });
    },
    // 支付宝拉起支付
    ALiPayReady(data) {
      AlipayJSBridge.call("tradePay", {
        tradeNO: data.tradeNo
      }, (data) => {
        if ("9000" == data.resultCode) {
          this.$router.replace('successPay')
        }
        else {
          alert("支付失败")
        }
      });
    },
    checkAll() {
      this.selectedIds = this.roadList.map(item => item.recordId);
    },
    toggleAll() {
      this.selectedIds = [];
    },
    // // 全选框改变
    // checkAllChange (isChecked) {
    //   // 改变所有的选中状态
    //   if (isChecked) {
    //     // 全选
    //     this.selectedIds = this.roadList.map(item => item.recordId);
    //   } else {
    //     // 反选
    //     this.selectedIds = [];
    //   }
    // },
    // 更新选中的条目数、总金额和ID
    updateSelectedInfo(list) {
      this.roadInsideAmount = 0;
      // 拼接数据承接
      const data = []
      list.forEach(item => {
        const obj = {
          parkNo: '',
          recordId: ''
        }
        this.roadInsideAmount += parseFloat(item.amount);
        obj.parkNo = item.parkNo
        obj.recordId = item.recordId
        data.push(obj)
      });
      // 临停费用 + 路侧费用
      this.totalAmount = (this.roadInsideAmount * 100) + Number(this.parkingInfo.orderInfo.actualToll)
      // 处理拼接数据
      this.roadInsideRecord = data.map(item => `${item.recordId}|${item.parkNo}`).join(',')
    },
  },
};
</script>

<style scoped lang="less">
::v-deep .van-dialog__heade {
  padding-top: 10px;
}

.ellipsis {
  white-space: nowrap;
  /* 不换行 */
  overflow: hidden;
  /* 隐藏超出部分 */
  text-overflow: ellipsis;
  /* 显示省略号 */
}

.list-item {
  margin-bottom: 10px;
}

.item {
  display: flex;
  align-items: center;
  padding-left: 10px;
}

.item-content {
  margin-left: 10px;
  font-size: 14px;
  text-align: start;
}

/* 设置弹窗内容区域的滚动条 */
.bottom-dialog .van-dialog__body {
  max-height: 80%;
  overflow-y: hidden;
}

/* 确保van-list区域是可滚动的 */
.scroll-container {
  max-height: 300px;
  /* 设置适当的最大高度，防止弹窗太大 */
  overflow-y: auto;
  /* 使容器可滚动 */
}

/* 给 van-list 设置滚动，确保下拉加载生效 */
.scroll-list {
  height: 100%;
}

body {
  background: #f5f5f5;
}

.greenCarNumber {
  background: linear-gradient(#b6fdd5, #01d466);
  color: #000;
  width: 125px;
}

.blueListCarNumber {
  background-color: #3365cb;
  color: #fff;
  padding: 4px 10px;
  text-align: center;
}

.greenListCarNumber {
  background: linear-gradient(#b6fdd5, #01d466);
  color: #000;
  padding: 4px 10px;
  text-align: center;
}

.price_text {
  font-size: 18px;
}

.card {
  padding: 10px 20px;
}

.title {
  font-size: 13px;
  color: #999;
}

.parkInfo {
  font-size: 16px;
  color: #333;
}

.parkName {
  font-size: 18px;
  font-weight: 600;
  margin-top: 10px;
}

.price {
  color: #ff8f1f;
  font-weight: 700;
  font-size: 26px;
}

.text_c {
  text-align: center;
}

.flex1 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex2 {
  display: flex;
  justify-content: space-around;
}

.blueCarNumber {
  display: inline-block;
  background-color: #3365cb;
  font-size: 18px;
  color: #fff;
  width: 125px;
  padding: 4px 10px;
  border-radius: 4px;
  letter-spacing: 1px;
}

.greenCarNumber {
  background: linear-gradient(#b6fdd5, #01d466);
  color: #000;
  width: 125px;
}

// 车牌号样式
.car_number {
  border: 2px solid #131313;
  border-radius: 5px;
  padding: 3px 8px;
  position: relative;
  margin: 5px 10px 5px 0;
  font-size: 16px;

  .bottomBorder {
    height: 2px;
    width: 100%;
    background-color: #0170E6;
    position: absolute;
    bottom: 0px;
    left: 0;
    border-radius: 0 0 5px 5px;
  }
}
</style>
